import styled from 'styled-components';
import { Form } from 'react-bootstrap';
import { colors, spacing, typography } from '../tokens';

// Label — wrapper Form.Label với typography tokens. Hỗ trợ `required`
// để render dấu * đỏ.
//
// `display: flex` (block-level) — không dùng `inline-flex` vì khi
// label đứng trước phần tử inline (vd <img>), chúng dồn cùng dòng
// → mobile chật sẽ overlap. Block-level đảm bảo label luôn chiếm
// dòng riêng, nội dung dưới rớt xuống dòng kế.
const StyledLabel = styled(Form.Label)`
  display: flex;
  align-items: center;
  gap: ${spacing[1]};
  font-size: ${typography.size.sm};
  font-weight: ${typography.weight.medium};
  color: ${colors.gray700};
  margin-bottom: ${spacing[2]};
`;

const Required = styled.span`
  color: ${colors.danger};
  font-weight: ${typography.weight.semibold};
`;

function Label({ required, children, ...props }) {
  return (
    <StyledLabel {...props}>
      {children}
      {required && <Required aria-hidden='true'>*</Required>}
    </StyledLabel>
  );
}

export default Label;
